var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"with-padding",staticStyle:{"justify-content":"end"}},[_vm._v(" "+_vm._s(_vm.formated)+" ")]):_c('div',{staticClass:"with-padding"})
}
var staticRenderFns = []

export { render, staticRenderFns }